import { PlatformLocation } from '@angular/common';
import { Injectable } from '@angular/core';
import { KnownRequestInstrumentationEvents } from '@office-start/telemetry-types';
import { OfficeHomePageErrorHandler } from '../../error-handler/error-handler.service';
import { InstrumentationParam, InstrumentationService, KnownInstrumentationEvents } from '../instrumentation/instrumentation.service';
import { InstrumentedHttp, InstrumentedHttpPromise } from '../instrumentation/instrumented-http.service';
import { HttpRequestOptions } from '../models/http-request-options.model';
import { ContextService } from '../shared-context/context.service';
import { AccessTokenConsumer, AccessTokenService } from './access-token.service';
import { OfficeHomeApiConfigService } from './officehome-api-config.service';
import { SchedulerService } from './scheduler.service';
import { XhrService } from './xhr.service';

/**
 * Service that makes request to Wac preboot API
 */
@Injectable({
    providedIn: 'root'
})
export class WacPrebootService extends XhrService {

    protected requestConfig: HttpRequestOptions;

    constructor(
        accessTokenService: AccessTokenService,
        instrumentationService: InstrumentationService,
        instrumentedHttp: InstrumentedHttp,
        contextService: ContextService,
        officeHomeApiConfigService: OfficeHomeApiConfigService,
        platformLocation: PlatformLocation,
        protected globalErrorHandler: OfficeHomePageErrorHandler,
        scheduler: SchedulerService
    ) {
        super(accessTokenService, instrumentationService, instrumentedHttp, AccessTokenConsumer.Graph, contextService, officeHomeApiConfigService, platformLocation, scheduler);
        this.requestConfig = {
            headers: new Map([
                ['content-type', 'application/x-www-form-urlencoded']
            ])
        };
    }

    public postPreboot(
        eventName: KnownInstrumentationEvents,
        otelEventName: KnownRequestInstrumentationEvents,
        url: string,
        data: any
    ): Promise<void> {
        return new Promise<void>((resolve, reject) => {
            const promiseCallback = (promise: InstrumentedHttpPromise<boolean>) => {
                promise
                    .instrument((result, params) => {
                        params[InstrumentationParam.RequestId] = this.getRequestIdFromResponse(result);
                    })
                    .then(() => resolve(null));
            };

            const errorCallback = error => {
                reject(error);
            };

            super.post(eventName, otelEventName, url, data, promiseCallback, errorCallback, this.requestConfig, undefined, undefined, undefined, undefined, AccessTokenConsumer.None);
        });
    }
}
